import { FC, ReactElement } from 'react';
import styled from 'styled-components';
// import { useDispatch } from 'react-redux';
import { useLogin } from '@/state/base/hooks';
import { useTranslation } from 'react-i18next';


const ConnectWalltView = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
`;
const ConnectImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
    width: 1.56rem;
    height: 1.06rem;
    margin-top: 0.84rem;
`;
const ConnectTip = styled.p`
    height: 0.25rem;
    font-size: 0.18rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 0.21rem;
    margin: 0.24rem 0;
`;
const ConnectBtn = styled.div`
    width: 2.29rem;
    height: 0.44rem;
    line-height: 0.44rem;
    background: #2561f4;
    border-radius: 0.4rem;

    font-size: 0.16rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
`;

const ConnectWallt: FC = (): ReactElement => {
    const [, login] = useLogin();
    const { t } = useTranslation();

    return (
        <ConnectWalltView>
            <ConnectImg src='/images/wallet.svg' alt="" />
            <ConnectTip>{t('main.connect wallet')}</ConnectTip>
            <ConnectBtn onClick={() => login()}>{t('main.connect')}</ConnectBtn>
        </ConnectWalltView>
    );
};

export default ConnectWallt;
